function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createStyles } from '@udecode/plate-styled-components';
import { css } from 'styled-components';
import React from 'react';
import { isCollapsed, createNodeHOC, createNodesHOC } from '@udecode/plate-common';
import { useEditorState } from '@udecode/plate-core';
import { Editor } from 'slate';
import { useFocused, useSelected } from 'slate-react';
var getPlaceholderStyles = function getPlaceholderStyles(props) {
  return createStyles(_objectSpread({
    prefixClassNames: 'Placeholder'
  }, props), {
    root: props.enabled && css(["::before{content:attr(placeholder);opacity:0.3;", "}"], {
      "display": "block",
      "position": "absolute",
      "cursor": "text"
    })
  });
};
var Placeholder = function Placeholder(props) {
  var children = props.children,
    element = props.element,
    placeholder = props.placeholder,
    _props$hideOnBlur = props.hideOnBlur,
    hideOnBlur = _props$hideOnBlur === void 0 ? true : _props$hideOnBlur,
    nodeProps = props.nodeProps;
  var focused = useFocused();
  var selected = useSelected();
  var editor = useEditorState();
  var isEmptyBlock = Editor.isEmpty(editor, element);
  var enabled = isEmptyBlock && (!hideOnBlur || isCollapsed(editor.selection) && hideOnBlur && focused && selected);
  return React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      className: child.props.className,
      nodeProps: _objectSpread(_objectSpread({}, nodeProps), {}, {
        styles: getPlaceholderStyles(_objectSpread({
          enabled: enabled
        }, props)),
        placeholder: placeholder
      })
    });
  });
};
var withPlaceholder = createNodeHOC(Placeholder);
var withPlaceholders = createNodesHOC(Placeholder);
export { Placeholder, getPlaceholderStyles, withPlaceholder, withPlaceholders };